import React, {useState} from "react"

declare global {
  interface Window {
    writeToAndroidClipboard(link: string): Function;
  }
}

export default function SharingButton ({url, type, title = '', className = ""}) {
  const [isActivated, setIsActivated] = useState(false);

  const link = url
  // NEXT_PUBLIC_VNP_BASE_URL
  let href = ''
  let icon = ''
  let onClick: React.MouseEventHandler<HTMLAnchorElement> | undefined
  switch (type) {
    case 'email':
      href = `mailto:?subject=${encodeURI(`Empfehlung: „${title}“`)}&body=${encodeURI(link)}`
      icon = 'icon-senden'
      title = "Artikel-Link per Mail versenden"
      break;
    case 'facebook':
      href = `https://www.facebook.com/sharer/sharer.php?u=${link}`
      icon = 'icon-facebook'
      title = "Artikel auf Facebook teilen"
      break;
    case 'whatsapp':
      href = `whatsapp://send?text=${link}`
      icon = 'icon-whatsapp'
      title = "Artikel auf WhatsApp teilen"
      break;
    case 'x':
      href = `https://x.com/intent/tweet?url=${link}`
      icon = 'icon-x'
      title = "Artikel auf X teilen"
      break; 
    case 'copy':
      href= "#"
      icon = 'icon-zwischenablage'
      title = "Artikel-Link kopieren"
      onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        if(window.writeToAndroidClipboard) {
          window.writeToAndroidClipboard(link)
        }
        else {
          navigator.clipboard.writeText(link);
        }
        setIsActivated(true);
        setTimeout(() => {
          setIsActivated(false);
        }, 3000)
      }
      break;
    default:
      href = ''
  }

  

  return <a href={href} title={title} aria-label={title} className={`${className} sharing-button sharing-button--${type} ${isActivated ? `sharing-button--${type}--active` : ''}`} onClick={onClick} target="_blank" rel="noopener noreferrer"><span className={`sharing-button__icon ${icon}`}></span></a>

}

    // case 'telegram':
    //   href = `https://t.me/share/url?url=${link}`
    //   icon = ''
    //   break;
    // case 'threema':
    //   href = `https://threema.id/compose?text=${link}`
    //   break;